// src/components/LoginDelivery.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LoginDelivery() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "❌ خطأ في تسجيل الدخول");
        return;
      }

      localStorage.setItem("token", data.token);

      if (data.user.role === "delivery") {
        localStorage.setItem("role", "delivery");
        navigate("/dashboard/drivers");
      } else {
        alert("🚫 غير مصرح لك بالدخول إلى لوحة التوصيل");
        localStorage.removeItem("token");
        navigate("/login");
      }
    } catch (err) {
      console.error(err);
      alert("❌ خطأ في الاتصال بالسيرفر");
    }
  };

  return (
    <div className="login-wrapper delivery-theme">
      <div className="login-card">
        <div className="login-header">
          <div className="icon">🚚</div>
          <h2>تسجيل دخول التوصيل</h2>
          <p>أدخل بياناتك للوصول إلى لوحة السائق</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>البريد الإلكتروني</label>
            <input
              type="email"
              placeholder="driver@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>كلمة المرور</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn delivery-btn">
            تسجيل الدخول
          </button>
        </form>

        <div className="role-switcher">
          <span>تسجيل الدخول كـ</span>
          <div className="roles">
            <button onClick={() => navigate("/login")} className="admin">
              👑 إداري
            </button>
            <button onClick={() => navigate("/login-hotel")} className="hotel">
              🏨 فندق
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .login-wrapper {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: "Segoe UI", Tahoma, sans-serif;
        }

        .delivery-theme {
          background: linear-gradient(135deg, #d4edda, #a9dfbf);
        }

        .login-card {
          background: #fff;
          width: 100%;
          max-width: 420px;
          padding: 30px;
          border-radius: 14px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.15);
        }

        .login-header {
          text-align: center;
          margin-bottom: 25px;
        }

        .login-header .icon {
          font-size: 42px;
          margin-bottom: 10px;
        }

        .login-header h2 {
          margin: 0;
          font-size: 24px;
          color: #333;
        }

        .login-header p {
          margin-top: 6px;
          font-size: 14px;
          color: #666;
        }

        .form-group {
          margin-bottom: 18px;
          text-align: right;
        }

        .form-group label {
          display: block;
          margin-bottom: 6px;
          font-size: 14px;
          font-weight: 600;
          color: #555;
        }

        .form-group input {
          width: 100%;
          padding: 12px;
          border-radius: 8px;
          border: 1px solid #ddd;
          font-size: 14px;
          outline: none;
        }

        .form-group input:focus {
          border-color: #28a745;
        }

        .login-btn {
          width: 100%;
          padding: 13px;
          margin-top: 10px;
          border: none;
          border-radius: 10px;
          font-size: 15px;
          font-weight: bold;
          cursor: pointer;
          transition: transform 0.2s, background 0.3s;
        }

        .login-btn.delivery-btn {
          background: #28a745;
          color: white;
        }

        .login-btn.delivery-btn:hover {
          background: #1e7e34;
          transform: translateY(-1px);
        }

        .role-switcher {
          margin-top: 25px;
          padding-top: 20px;
          border-top: 1px solid #eee;
          text-align: center;
        }

        .role-switcher span {
          display: block;
          margin-bottom: 12px;
          font-size: 14px;
          color: #666;
        }

        .roles {
          display: flex;
          justify-content: center;
          gap: 10px;
        }

        .roles button {
          padding: 8px 16px;
          border: none;
          border-radius: 20px;
          font-size: 13px;
          font-weight: bold;
          cursor: pointer;
        }

        .roles .admin {
          background: #007bff;
          color: #fff;
        }

        .roles .admin:hover {
          background: #0056b3;
        }

        .roles .hotel {
          background: #ffc107;
          color: #333;
        }

        .roles .hotel:hover {
          background: #e0a800;
        }
      `}</style>
    </div>
  );
}
